export default __webpack_public_path__ + "static/homepage_title_background-a44c32f9af5222b012d154fc8f688944.svg";